module.exports = __webpack_public_path__ + "static/media/image_52.ec5fa1d2.png";